import { Toaster as Sonner } from "sonner";

export function Toaster() {
    return (
        <Sonner
            theme="dark"
            position="bottom-center"
            toastOptions={{
                className:
                    "bg-[#1f1f1f] border-white/[0.08] text-[#cccccc] font-sans text-sm",
                descriptionClassName: "text-[#8b949e] font-mono text-xs",
            }}
            richColors
        />
    );
}
